import React from "react";
import {
  mdiFileDocumentEditOutline,
  mdiSendOutline,
  mdiAlertCircleOutline,
} from "@mdi/js";
import HowItWorksModal from "app/components/common/HowItWorksModal";

const ROWS = [
  {
    icon: mdiFileDocumentEditOutline,
    title: "Set up once, use for every job",
    body: "Write your contract template here. Morph fills in the client name, address, fee, and inspection date automatically for each job — no edits needed per job.",
  },
  {
    icon: mdiSendOutline,
    title: "Contracts go out with job setup",
    body: 'When you finish Job Setup with "Contract" checked, Morph sends the contract to your client for electronic signature.',
  },
  {
    icon: mdiAlertCircleOutline,
    title: "Void when details change",
    body: "If a job changes after the contract is sent, void it from the job. The client is notified. You choose when to send a new one.",
  },
];

const ContractHowItWorksModal = ({ show, onClose }) => (
  <HowItWorksModal
    show={show}
    onHide={onClose}
    title="How contract management works"
    rows={ROWS}
  />
);

export default ContractHowItWorksModal;
